import React from 'react';
import colors from '../ColorConfig/colorconfig';
import ProcessStep from './processstep';
import ConnectionLines from './connectionline';

const { gray, primary } = colors;

const DesktopProcessFlow = ({
  isSectionInView,
  visibleSteps,
  hoveredStep,
  animationStarted,
  processSteps,
  shouldAnimateOut,
  onMouseEnter,
  onMouseLeave
}) => {
  return (
    <div style={{ 
      display: window.innerWidth > 992 ? 'block' : 'none',
      position: 'relative',
      height: '450px',
      maxWidth: '1400px',
      margin: '0 auto',
      marginBottom :'-20px'
    }}>
     <ConnectionLines 
        isSectionInView={isSectionInView}
        animationStarted={animationStarted}
        shouldAnimateOut={shouldAnimateOut}
        processSteps={processSteps}
        visibleSteps={visibleSteps}
        isMobile={false}
      />
      
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        height: '60%',
        position: 'relative',
        zIndex: 2,
       marginBottom :'-40px'
      }}>
        {processSteps.map((step, index) => {
          const isEven = index % 2 === 1;
          const isStepVisible = visibleSteps.includes(index);
          
          return (
            <ProcessStep
              key={step.id}
              step={step}
              index={index}
              isEven={isEven}
              isStepVisible={isStepVisible}
              isHovered={hoveredStep === index}
              shouldAnimateOut={shouldAnimateOut}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              isDesktop={true}
            />
          );
        })}
      </div>
    </div>
  );
};

export default DesktopProcessFlow;